import React from 'react';

import { MyAccountsGeneral } from '@/modules/transaction/components/MyAccounts/MyAccountsGeneral';

const MyAccountsGeneralPage = () => (
  <MyAccountsGeneral />
);
export default MyAccountsGeneralPage;
